import FavoriteIcon from './FavoriteIcon/FavoriteIcon';
import { RefinedCruiseLoadingSkeletonBase, RefinedCruiseLoadingSkeletonButton, RefinedCruiseLoadingSkeletonButtons, RefinedCruiseLoadingSkeletonDeparturePort, RefinedCruiseLoadingSkeletonImage, RefinedCruiseLoadingSkeletonLocationList, RefinedCruiseLoadingSkeletonMain, RefinedCruiseLoadingSkeletonPrice, RefinedCruiseLoadingSkeletonPriceDetail, RefinedCruiseLoadingSkeletonShip, RefinedCruiseLoadingSkeletonShipSocials, RefinedCruiseLoadingSkeletonSocials } from './RefinedCruiseLoadingSkeleton.styles';
import ShareIcon from './ShareIcon/ShareIcon';

function RefinedCruiseLoadingSkeleton() {
  return (
    <RefinedCruiseLoadingSkeletonBase>
      <RefinedCruiseLoadingSkeletonImage/>
      <RefinedCruiseLoadingSkeletonMain>
        <RefinedCruiseLoadingSkeletonShipSocials>
          <RefinedCruiseLoadingSkeletonShip/>
          <RefinedCruiseLoadingSkeletonSocials>
            <FavoriteIcon/>
            <ShareIcon/>
          </RefinedCruiseLoadingSkeletonSocials>
        </RefinedCruiseLoadingSkeletonShipSocials>
        <RefinedCruiseLoadingSkeletonDeparturePort/>
        <RefinedCruiseLoadingSkeletonLocationList/>
        <RefinedCruiseLoadingSkeletonPriceDetail>
          <RefinedCruiseLoadingSkeletonPrice/>
          <RefinedCruiseLoadingSkeletonButtons>
            <RefinedCruiseLoadingSkeletonButton/>
            <RefinedCruiseLoadingSkeletonButton className="hidden-skeleton-button"/>
          </RefinedCruiseLoadingSkeletonButtons>
        </RefinedCruiseLoadingSkeletonPriceDetail>
      </RefinedCruiseLoadingSkeletonMain>
    </RefinedCruiseLoadingSkeletonBase>
  );
}

export default RefinedCruiseLoadingSkeleton;